import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateVoiceForm from "@/components/CreateVoiceForm";

export const Route = createFileRoute("/dashboard/settings/voices/new")({
  component: CreateVoicePage,
});

function CreateVoicePage() {
  return <CreateVoicePageComponent />;
}

// Exported for testing
export function CreateVoicePageComponent() {
  return (
    <EntityFormPage
      title="Create Voice"
      description="Add a new voice to the catalog."
      backHref="/dashboard/settings/voices"
    >
      <CreateVoiceForm />
    </EntityFormPage>
  );
}
